import * as v from 'valibot'
import * as http from '@/util/http'

const IsAdminSchema = v.object({
  isAdmin: v.boolean(),
})

export async function checkAdmin() {
  const { data } = await http.get('/api/v1/user/is-admin')
  const result = v.safeParse(IsAdminSchema, data)
  // fail closed: an unexpected response must never grant admin access
  if (!result.success || !result.output.isAdmin) {
    throw new Response('not found', { status: 404 })
  }
}
